import { LILI_PRIVACY_POLICY_URL, LILI_TERMS_OF_USE_URL } from '@Types/consts.ts';
import { useTranslation } from 'react-i18next';

interface TermsAndConditionsProps {
  onTncClick: () => void;
  onPrivacyPolicyClick: () => void;
}
export const TermsAndConditions = ({
  onTncClick,
  onPrivacyPolicyClick,
}: TermsAndConditionsProps) => {
  const { t } = useTranslation();

  return (
    <div className='flex items-center text-[12px] flex-col font-metricR text-text-main-tertiary '>
      <p>{t('pages.home.byClicking')}</p>
      <div className='flex items-center font-metricR text-text-main-tertiary gap-[4px]'>
        <a
          className='underline font-metricR text-text-main-tertiary'
          href={LILI_TERMS_OF_USE_URL}
          target='_blank'
          id='terms-of-us'
          onClick={(e) => {
            e.stopPropagation();
            onTncClick();
          }}>
          {t('pages.home.terms')}
        </a>
        <p>{t('pages.home.and')}</p>
        <a
          className='underline font-metricR text-text-main-tertiary'
          href={LILI_PRIVACY_POLICY_URL}
          target='_blank'
          id='privacy-policy'
          onClick={(e) => {
            e.stopPropagation();
            onPrivacyPolicyClick();
          }}>
          {t('pages.home.privacy')}
        </a>
      </div>
    </div>
  );
};
